export default function () {
  // this.getStaticComapny()
}



// WEBPACK FOOTER //
// ./src/app/patient/profile-company/components/statistics/resources/mounted.js